class AppCookie {
    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    setCookie(cname, cvalue, minutes) {
        const d = new Date();
        d.setTime(d.getTime() + minutes * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    deleteCookie(name) {
        document.cookie =
            name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }

    setLoginCookie(res) {
        // Save token - 7 days = 10080 minutes
        if (res.authorization && res.authorization.token) {
            this.setCookie('token', res.authorization.token, 10080);
        }
        // Save user data
        if (res.data) {
            this.setCookie('user', JSON.stringify(res.data), 10080);
        }
    }
}

export default new AppCookie;
